import { jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM3 8c0 2.757 2.243 5 5 5s5-2.243 5-5-2.243-5-5-5-5 2.243-5 5Zm4.337 1.74h1.129v.001c.362 0 .638-.25.638-.637l1.137.069c0 .973-.646 1.688-1.602 1.688H5.76V9.845c.542-.19.896-.543.896-1.051 0-.093-.017-.186-.034-.278l-.001-.007h-.836v-.948h.491a2.24 2.24 0 0 1-.112-.724c0-.844.689-1.697 1.895-1.697 1.327 0 1.801.887 1.845 1.594l-1.129.301c-.008-.525-.25-.827-.698-.827-.344 0-.663.216-.663.672 0 .259.06.457.146.68h1.517v.949H7.863a.948.948 0 0 1 .008.155c0 .405-.147.818-.534 1.077Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  e as Pound
};
